import { map, of } from 'rxjs';
import { AppStateService } from '../../app-state/app-state.service';
import { Injector } from '@angular/core';
import { ResidentPreferenceData, ResidentPreferenceDataRaw } from '@resparke/models/resident.model';
import { FamilyInviteStatus } from '@resparke/models/family.model';
import { Resident } from '@resparke/models/client-types';


export interface ResidentSubscriptionResponse {
  facilityId: string;
  preference: ResidentPreferenceDataRaw
  resident: Resident
}

export const handle = (injector: Injector, response: ResidentSubscriptionResponse) => {
  const appState = injector.get(AppStateService);

  return of(response).pipe(
    map(response => {
      if (response.resident) {
        response.resident = completeResidentRecord(response.resident);
        stateUpdateResident(response.resident);
      }
      if (response.preference) {
        stateUpdateResidentPreferenceData(response.preference);
      }
    }),
  );

  /**
   * @description Add missing values that haven't been set.
   */
  function completeResidentRecord(resident: Resident) {
    return {
      ...resident,
      familyStatus: Array.isArray(resident.familyStatus) && resident.familyStatus.length ? resident.familyStatus.reverse() : [{ status: FamilyInviteStatus.DETAILS_REQUIRED }]
    }
  }

  /**
   * @description Update currentResident (if applicable) and/or the resident in residents collection.
   * @param resident
   */
  function stateUpdateResident(resident: Resident) {
    appState.set('currentResident', resident);
  }

  /**
   * @description Update current Resident Preference data if applicable
   * @param preference
   */
  function stateUpdateResidentPreferenceData(preference: ResidentPreferenceDataRaw) {

    const newPreference: ResidentPreferenceData = {
      id: preference.id,
      conversationStarters: preference.conversationStarters?.slice(-1)[0],
      cultureValuesBelieves: preference.cultureValuesBelieves?.slice(-1)[0],
      music: preference.music?.slice(-1)[0],
      languageCountry: preference.languageCountry?.slice(-1)[0],
      profile: preference.profile?.slice(-1)[0],
      peoplePets: preference.peoplePets?.slice(-1)[0],
      occupationsLife: preference.occupationsLife?.slice(-1)[0],
      hobbiesInterestsSports: preference.hobbiesInterestsSports?.slice(-1)[0],
      notes: preference.notes?.slice(-1)[0],
    } as ResidentPreferenceData;
    appState.set('currentResidentPreferenceData', newPreference);
  }
}